/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui-robot-license-grid mat-icon.entry-status{font-size:18px;line-height:22px}.ui-robot-license-grid mat-icon.entry-status-active{color:#7cc76c}.ui-robot-license-grid mat-icon.entry-status-pending{color:#f4a300}.ui-robot-license-grid mat-icon.entry-status-inactive{color:#ff6325}"];
export { styles as styles };
